import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { IAppConfig } from '../../core/models/app-config.model';
import { AppConfigService } from '../../core/services/app-config.service';
import { SessionStorageService } from "../services/session-storage.service";
import { IdToken } from '../../constants/constants';

@Injectable({
  providedIn: "root",
})
export class LoginService {
  public isLoggedIn: boolean = false;
  public _logging$ = new BehaviorSubject<boolean>(false);
  public isLoggedIn$ = this._logging$.asObservable();
  public _loggingsubject$ = new Subject<boolean>();
  public isLoggedISubjectn$ = this._logging$.asObservable();
  private appConfig: IAppConfig = {} as IAppConfig;

  constructor(private msalAuthService: MsalService, private appConfigService: AppConfigService, private sessionStorageService: SessionStorageService) {
    this.appConfig = this.appConfigService.get();
  }

  setUserLoginStatus(): any {
    this.isLoggedIn = this.msalAuthService.instance.getAllAccounts().length > 0;
    const accessTokenRequest = {
      scopes: ["user.read"],
      account: this.msalAuthService.instance.getAllAccounts()[0],
      forceRefresh: false
    };

    if (this.isLoggedIn) {
      const idToken = this.sessionStorageService.getItem(IdToken);
      let idTokenExpiration = 0;

      if (idToken) {
        // Decode the ID token to extract the expiration time
        const tokenParts = idToken.split('.');
        if (tokenParts.length === 3) {
          const payload = JSON.parse(atob(tokenParts[1]));
          idTokenExpiration = payload.exp || 0;
        }
      }
      const currentTime = Math.floor(Date.now() / 1000);
      if (currentTime >= idTokenExpiration) {
        accessTokenRequest.forceRefresh = true;
      }
      this.msalAuthService.acquireTokenSilent(accessTokenRequest).subscribe((accessTokenReponse) => {
        if (accessTokenReponse != null) {
          // Acquire token silent success
          const idToken = accessTokenReponse.idToken;
          // Call your API with token
          this.sessionStorageService.removeItem(IdToken);
          this.sessionStorageService.setItem(IdToken, idToken);
        }
      })
    }
    this._logging$.next(this.isLoggedIn);
  }

  getUserLoginStatus(): any {
    return this._logging$;
  }
}
